import { formatAmount } from "@/lib/helpers/format-amount";
interface TermsForPromoType {
  predicates: Array<boolean | undefined>,
  terms: string[]
}

export const PASSPORT_TERMS = [
  'passport',
  'pssport',
  'pasport',
  'passprt',
  'pbs passport',
  'member',
  'membership',
];

export const KIDS_TERMS = [
  'pbs kids',
  'pbs kid',
  'pbskids',
  'pbskid',
  'kids',
  'kid',
  'daniel tiger',
  'daniel',
  'wild kratts',
  'kratts',
  'sesame',
  'sesame street',
  'curious george',
];

export const ACTIVATE_TERMS = [
  'activate',
  'acitvate',
  'activation',
  'roku',
  'activate roku',
  'apple tv',
  'activate apple tv',
  'samsung',
  'activate samsung',
  'activate samsung tv',
  'fire tv',
  'lg tv',
  'pbs.org/activate',
];

export const FOUNDATION_TERMS = [
  'pbs foundation',
  'foundation'
];

export const DONATE_TERMS = [
  'donate',
  'donation',
];

export const APP_TERMS = [
  'pbs app',
  'app',
];

export function buildTermsForPromotion(stationCommonName?: string): { [key: string]: TermsForPromoType } {
  return {
    passport: {
      predicates: [
        stationCommonName !== undefined
      ],
      terms: PASSPORT_TERMS
    },
    activate: {
      predicates: [],
      terms: ACTIVATE_TERMS
    },
    foundation: {
      predicates: [],
      terms: FOUNDATION_TERMS
    },
  }
}

export const TERMS_FOR_PROMOTIONS: { [key: string]: TermsForPromoType } = {}

export function buildPossiblePromotedResults(stationCommonName?: string, annualPassportQualifyingAmount?: number): { [key: string]: PromotedResultType[] } {
  const annualAmount = formatAmount(annualPassportQualifyingAmount || 0);
  const monthlyAmount = formatAmount((annualPassportQualifyingAmount || 0) / 12);

  return {
    passport: [{
        title: `What is Passport?`,
        description: `Donate $${monthlyAmount} per month or $${annualAmount} per year to get extended access to past seasons of PBS shows, stream early releases of new series, and binge watch your favorite PBS shows with ${stationCommonName} Passport.`,
        item_type: "remote_asset",
        external_url: "https://www.pbs.org/passport/learn-more/",
        promoted: true,
    },{
      title: `Shows Available with Passport`,
      description: `Enjoy your favorite dramas, food, and history shows, plus more, available with ${stationCommonName} Passport.`,
      item_type: "remote_asset",
      external_url: '/explore/passport',
      promoted: true,
    }],

    activate: [{
      title: "Sign into the PBS App",
      description: "Sign into the PBS App on your device so that you can watch award-winning national programming and locally produced shows. Catch up on the episodes you may have missed and watch your favorite, full-length shows free and on-demand.",
      item_type: "remote_asset",
      external_url: "https://www.pbs.org/tv/",
      promoted: true,
    }],

    foundation: [{
      title: "PBS Foundation",
      description: "Support PBS by donating to the PBS Foundation, PBS’s national fundraising entity.",
      item_type: "remote_asset",
      external_url: "https://www.pbs.org/foundation/",
      image_url: `/images/results/pbs-logotype--promoted-search.png`,
      promoted: true,
    }],
  }
}

export type TERMS_KEYS_TYPE = keyof typeof TERMS_FOR_PROMOTIONS
export type TERMS_KEYS_VALUES_TYPE = `${TERMS_KEYS_TYPE}`

export const DISQUALIFYING_FILTERS = [
  "filter_video_type",
  "filter_duration",
  "filter_show",
  "filter_video_availability",
  "filter_descriptive",
]

export interface PromotedResultType {
  title: string;
  description: string;
  item_type: string;
  external_url: string;
  image_url?: string;
  promoted: boolean;
}
